<template>
  <v-row no-gutters>
    <v-col>
      <v-autocomplete
          :disabled="disabled"
          ref="visitor-selector"
          :key="index+'pass_order_visitor'"
          v-if="!addVisitor[index].visitor && !addVisitor[index].portal_user"
          v-model="item.visitor_id"
          :items="visitors"
          label="Посетитель"
          outlined
          :error="hasSpecialError('none_field_error')"
          :error-messages="getSpecialError('none_field_error')"
          :search-input.sync="search_inputs.auto"
          :menu-props="{ maxWidth: 735 }"
      >
        <template v-slot:item="data">
          <template v-if="typeof data.item !== 'object'">
            <v-list-item-content></v-list-item-content>
          </template>
          <template v-else>
            <v-list-item-content class="text-center" style="-moz-hyphens: auto; -webkit-hyphens: auto; -ms-hyphens: auto;">
              {{ data.item.text }}
            </v-list-item-content>
          </template>
        </template>
        <template v-slot:label>
          Посетитель <strong class="red--text" v-if="orderType !== 4">*</strong>
        </template>
        <template v-slot:prepend-item>
          <v-btn
              block
              elevation="0"
              text
              @click="newVisitor(index)"
          >
            <v-icon>add</v-icon>
            Добавить нового посетителя
          </v-btn>
          <v-btn
              block
              elevation="0"
              text
              @click="changeAutocomplite(false, index)"
          >
            <v-icon>search</v-icon>
            Поиск среди обучающихся <br v-if="$vuetify.breakpoint.mobile"> и работников университета
          </v-btn>
          <v-divider class="primary"></v-divider>
        </template>
      </v-autocomplete>
      <!-- Блок добавления посетителя из списка УЗ портала -->
      <loading-autocomplete
          ref="portal-selector"
          :key="index+'portal_visitor'"
          v-else-if="addVisitor[index].portal_user && !addVisitor[index].visitor"
          placeholder="Введите ФИО и выберете из предложенных вариантов"
          label="Посетитель"
          :menu-props="{ maxWidth: 730 }"
          v-model="item.user"
          search-parameter="fio"
          outlined
          :load-fios="false"
          :required="true"
          :url="user_selector"
          :error="hasSpecialError('none_field_error')"
          :error-messages="getSpecialError('none_field_error')"
          :search-input.sync="search_inputs.loading"
      >
        <template v-slot:no-data>
          <div>
            Для поиска начните набирать ФИО, <br> и подождите 1 секунду, либо нажмите Enter
          </div>
        </template>
        <template v-slot:prepend-item>
          <v-btn
              block
              elevation="0"
              text
              @click="newVisitor(index)"
          >
            <v-icon>add</v-icon>
            Добавить нового посетителя
          </v-btn>
          <v-btn
              block
              elevation="0"
              text
              @click="changeAutocomplite(true, index)"
          >
            <v-icon>search</v-icon>
            Поиск среди внешних посетителей
          </v-btn>
          <v-divider class=" primary" ></v-divider>
        </template>
      </loading-autocomplete>
      <!-- Блок добавления нового посетителя -->
      <v-card
          :disabled="disabled"
          :key="index+'new_visitor'"
          v-else
          class="pa-4 mb-2 rounded-lg"
          elevation="0"
          color="grey lighten-3"
      >
        <v-card-title class="text-left subtitle-1 px-0 pt-0 pb-2">
          Добавление нового посетителя:
        </v-card-title>
        <v-form
            ref="form"
            v-model="disabled_apply"
            lazy-validation
        >
          <v-row no-gutters class="pa-0">
            <v-col cols="10" md="4" class="pr-md-1">
              <v-text-field
                  ref="new-visitor-last-name"
                  class="pa-0 pr-md-4"
                  v-model="item.last_name"
                  label="Фамилия"
                  :rules="[rules.name]"
                  outlined
                  :disabled="addVisitor[index].is_copy"
                  :error="hasSpecialError('last_name')"
                  :error-messages="getSpecialError('last_name')"
              >
                <template v-slot:label>
                  Фамилия <strong class="red--text">*</strong>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="2" class="pl-3 mt-2" v-show="$vuetify.breakpoint.smAndDown">
              <v-btn
                  fab
                  icon
                  small
                  color="primary"
                  @click="replyCreateVisitor(index)"
              >
                <v-icon>reply</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12" md="4" class="pr-md-1">
              <v-text-field
                  class="pa-0 pr-md-4"
                  v-model="item.first_name"
                  label="Имя"
                  :rules="[rules.name]"
                  outlined
                  :disabled="addVisitor[index].is_copy"
                  :error="hasSpecialError('first_name')"
                  :error-messages="getSpecialError('first_name')"
              >
                <template v-slot:label>
                  Имя <strong class="red--text">*</strong>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                  class="pa-0"
                  v-model="item.middle_name"
                  label="Отчество"
                  outlined
                  :disabled="addVisitor[index].is_copy"
                  :error="hasSpecialError('middle_name')"
                  :error-messages="getSpecialError('middle_name')"
              ></v-text-field>
            </v-col>
            <v-col cols="2" md="1" class="pl-sm-3 mt-2" v-show="$vuetify.breakpoint.mdAndUp">
              <v-btn
                  fab
                  icon
                  small
                  color="primary"
                  @click="replyCreateVisitor(index)"
              >
                <v-icon>reply</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
        <v-row no-gutters class="pa-0">
          <v-col cols="12" :md="new_organization ? 12 : 6">
            <loading-autocomplete
                ref="organization-selector"
                v-if="!new_organization && addVisitor[index].visitor && !private_person"
                placeholder="Введите название и выберете из предложенных вариантов"
                label="Организация"
                outlined
                :required="true"
                :menu-props="{ maxWidth: 700, maxHeight: 150 }"
                v-model="item.organization"
                search-parameter="search"
                :item-text="getText"
                :load-fios="false"
                :url="organizations"
                :disabled="addVisitor[index].is_copy"
                :error="hasSpecialError('organization')"
                :error-messages="getSpecialError('organization')"
                return-object
            >
              <template v-slot:no-data>
                <div>
                  Для поиска начните набирать название, <br> и подождите 1 секунду, либо нажмите Enter
                </div>
              </template>
              <template v-slot:prepend-item>
                <v-btn
                    block
                    elevation="0"
                    text
                    @click="addNewOrganization"
                >
                  <v-icon>add</v-icon>
                  Добавить новую организацию
                </v-btn>
              </template>
            </loading-autocomplete>
            <!-- Блок добавления новой организации -->
            <v-card
                v-if="new_organization && addVisitor[index].visitor && !private_person"
                class="pa-4 mb-2"
                elevation="1"
                color="grey lighten-2"
            >
              <v-card-title class="subtitle-2 px-0 pt-0 pb-2 text-left">
                Добавление новой организации:
              </v-card-title>
              <v-row no-gutters class="pa-0">
                <v-col cols="10" md="11" class="pr-md-1">
                  <v-text-field
                      ref="new-organization-full-name"
                      class="pa-0"
                      v-model="item.organization.full_name"
                      label="Полное наименование"
                      outlined
                      :error="hasSpecialError('organization', 'full_name')"
                      :error-messages="getSpecialError('organization', 'full_name')"
                  >
                    <template v-slot:label>
                      Полное наименование <strong class="red--text">*</strong>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="2" md="1"  class="pl-3 mt-2">
                  <v-btn
                      fab
                      icon
                      small
                      color="primary"
                      @click="removeNewOrganization"
                  >
                    <v-icon>reply</v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                      class="pa-0"
                      v-model="item.organization.short_name"
                      label="Краткое наименование"
                      outlined
                      :error="hasSpecialError('organization', 'short_name')"
                      :error-messages="getSpecialError('organization', 'short_name')"
                  >
                    <template v-slot:label>
                      Краткое наименование <strong class="red--text">*</strong>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                      class="pa-0"
                      v-model="item.organization.inn"
                      label="ИНН"
                      outlined
                      maxlength="12"
                      :error="hasSpecialError('organization', 'inn')"
                      :error-messages="getSpecialError('organization', 'inn')"
                  >
                    <template v-slot:label>
                      ИНН <strong class="red--text">*</strong>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                      class="pa-0"
                      v-model="item.organization.legal_address"
                      label="Адрес"
                      outlined
                      :error="hasSpecialError('organization', 'legal_address')"
                      :error-messages="getSpecialError('organization', 'legal_address')"
                  >
                    <template v-slot:label>
                      Адрес <strong class="red--text">*</strong>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
<!--          <v-col cols="12" :md="new_organization || private_person ? 12 : 6" class="mt-n1">-->
          <v-col cols="12" class="mt-n2">
            <v-alert
                class="rounded-lg"
                type="info"
                :icon="false"
                outlined
            >
              <b>Уважаемые пользователи!</b>
              <p class="pa-0 ma-0">
                Обратите внимание, что согласно действующим правилам, иностранным гражданам, не имеющим юридических отношений с Университетом, запрещено оформлять электронные пропуска.
              </p>
            </v-alert>
            <v-checkbox
                v-if="!new_organization"
                :class="'pa-0 mx-0 mb-n2'"
                :disabled="addVisitor[index].is_copy"
                @click="privatePerson"
                label="Частное лицо"
            ></v-checkbox>
<!--            <v-checkbox-->
<!--                :class="new_organization || private_person ? 'pa-0 mx-0 mt-4 mb-n2' : 'pl-md-8 pa-0 mx-0 mt-0 mb-n2'"-->
<!--                :disabled="addVisitor[index].is_copy"-->
<!--                v-model="item.is_foreigner"-->
<!--                label="Является иностранным гражданином"-->
<!--            ></v-checkbox>-->
          </v-col>
        </v-row>
        <v-divider class="primary mb-2 pb-1" v-if="orderType === 3 && orderVisitors.length > 1"></v-divider>
        <v-alert v-if="visitor_error[index] && item.last_name && item.first_name" type="error">{{ visitor_error[index] }}</v-alert>
      </v-card>
    </v-col>
    <v-col cols="2" md="1" class="pl-1 mt-2" v-if="orderType === 3 && orderVisitors.length > 1">
      <v-btn
          fab
          icon
          small
          color="primary"
          @click="deleteNewVisitor(index)"
      >
        <v-icon>close</v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import LoadingAutocomplete from "@/modules/core/components/LoadingAutocomplete";
import FormErrorsMixin from "@/mixins/FormErrorsMixin"

export default {
  name: "OrderVisitors",
  props: {
    disabled: Boolean,
    item: Object,
    index: Number,
    visitors: Array,
    user_selector: String,
    organizations: String,
    addVisitor: Array,
    orderVisitors: Array,
    specialError: {Array, default: []},
    visitor_error: Array,
    orderType: Number
  },
  components: {
    LoadingAutocomplete
  },
  mixins: [FormErrorsMixin],
  data() {
    return {
      search_inputs: {
        auto: "",
        loading: ""
      },
      new_organization: false,
      private_person: false,
      disabled_apply: true,
      rules: {
        name: value => {
          const pattern = /^[а-яёА-ЯЁ]+(?:[- ][а-яёА-ЯЁ]+)*$/
          return pattern.test(value) || "Некорректный ввод"
        }
      }
    }
  },
  watch: {
    "orderType"() {
      this.new_organization = false
      this.item.organization = undefined
    }
  },
  computed: {

  },
  methods: {
    getText(value){
      if(value !== undefined)
        return `${value.inn}(${value.short_name})`
      else
        return ""
    },
    // Функция для моментального поиска по списку посетителей при смене Внутреннего селектора на Портальный и наоборот
    changeAutocomplite(reverse=false, index){
      if (this.orderVisitors[index].visitor_id) {
        delete this.orderVisitors[index].visitor_id
      } else if (this.orderVisitors[index].user) {
        delete this.orderVisitors[index].user
      }
      this.addVisitor[index].portal_user = !reverse;
      if(this.addVisitor[index].is_copy) {
        this.addVisitor[index].is_copy = !reverse
      }
      this.$nextTick(() => {
        if (!reverse) {
          this.$refs["portal-selector"].focus();
          this.$nextTick(() => {
            this.search_inputs.loading = this.search_inputs.auto;
          })
        } else {
          this.$refs["visitor-selector"].focus();
          this.$refs["visitor-selector"].isMenuActive = true;
          this.$nextTick(() => {
            this.search_inputs.auto = this.search_inputs.loading;
          })
        }
      })
    },
    // Добавление еще одного посетителя, фокус автоматически ставится на фамилию
    newVisitor(index) {
      this.item.organization = undefined
      this.new_organization = false
      this.private_person = false
      if (this.orderVisitors[index].visitor_id) {
        delete this.orderVisitors[index].visitor_id
      }
      if (this.orderVisitors[index].user) {
        delete this.orderVisitors[index].user
      }
      this.addVisitor[index].visitor = true
      this.$nextTick(() => {
        this.$refs["new-visitor-last-name"].focus();
        this.$refs["new-visitor-last-name"].inputMode;
      })
    },
    // Отмена создания нового посетителя, фокус на поле селектора
    replyCreateVisitor(index) {
      this.item.organization = undefined
      this.new_organization = false
      this.private_person = false
      this.addVisitor[index].visitor = false
      this.orderVisitors[index] = {}
      if (this.addVisitor[index].is_copy) {
        this.addVisitor[index].is_copy = false
      }
      if (this.addVisitor[index].portal_user) {
        this.$nextTick(() => {
          this.$refs["portal-selector"].focus();
        })
      } else {
        this.$nextTick(() => {
          this.$refs["visitor-selector"].focus();
          this.$refs["visitor-selector"].isMenuActive = true;
        })
      }
    },
    // Удаление одного из посетителей массовой заявки
    deleteNewVisitor(index) {
      if (this.orderVisitors.length > 1) {
        this.orderVisitors.splice(index, 1)
        this.addVisitor.splice(index, 1)
      }
    },
    // Добавление и удаление создания новой организации
    addNewOrganization() {
      this.item.organization = {}
      this.new_organization = true
      this.$nextTick(() => {
        this.$refs["new-organization-full-name"].focus();
        this.$refs["new-organization-full-name"].inputMode;
      })
    },
    removeNewOrganization() {
      this.item.organization = undefined
      this.new_organization = false
      this.$nextTick(() => {
        this.$refs["organization-selector"].focus();
        this.$refs["organization-selector"].isMenuActive = true;
      })
    },
    // Буль Частное лицо: organization id=25 !!!ЖЕСТКО!!!
    privatePerson() {
      if (!this.private_person) {
        this.private_person = true
        this.item.organization = {
          full_name: "ЧАСТНОЕ ЛИЦО",
          inn: "0000000000",
          legal_address: "ЧАСТНОЕ ЛИЦО",
          short_name: "ЧАСТНОЕ ЛИЦО",
          dadata: false,
          id: 1
        }
      } else {
        this.item.organization = undefined
        this.private_person = false
      }
    },
    // Функция для проверки наличия специфичных ошибок
    hasSpecialError(field, include_field) {
      let result = this.specialError[this.index]
      if (include_field) {
        if (result)
          if(result[field]) {
            let result_include = result[field]
            if (result_include[include_field])
              return true
          }
      } else {
        if (result)
          if(result[field])
            return true
        return false
      }
    },
    // Функция для отображения специфичных ошибок
    getSpecialError(field, include_field) {
      let result = this.specialError[this.index]
      if (include_field) {
        if(result) {
          let result_include = result[field]
          if (result_include)
            return result_include[include_field]
        }
      } else {
        if (result)
          return result[field]
        return ""
      }
    }
  }
}
</script>

<style scoped>

</style>
